"use client";

import { useState } from "react";
import { API_URL } from "../../../utils/common";

export interface AdminPerfil {
    id: number;
    nombre: string;
    descripcion: string;
    estatus: number | string;
}

export const useGetAdminUserPerfiles = () => {

    const [perfiles, setPerfiles] = useState<AdminPerfil[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const getToken = () => localStorage.getItem("jwt");

    const obtenerPerfiles = async () => {

        setLoading(true);
        setError(null);
        try {
            const token = getToken();

            if (!token) {
                throw new Error("Token no encontrado");
            }

            const response = await fetch(`${API_URL}/cms/admin/perfiles`, {
                method: "GET",
                headers: {
                    Authorization: `bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                throw new Error("Error al obtener perfiles");
            }

            const data = await response.json();
            setPerfiles(data);

        } catch (err: any) {
            console.error(err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return {
        perfiles,
        loading,
        error,
        obtenerPerfiles,
    };
};